
import * as angular from "angular";

import { IDriver } from "@interfaces/IDriver";

import "./driverScore.scss";

interface IDriverScoreComponentBindings {
    driver: IDriver;
    score: IDriverScores;
}

export interface IDriverScores {

    overallScore?: number;

    harshBraking: number;
    overAcceleration: number;
    harshCornering: number;
    overSpeeding: number;

    // May want moving somewhere more appropriate
    fuelUsedTotal?: number;
    fuelLevel?: number[];
    fuelFilled?: number;
    fuelStolen?: boolean;
}

class DriverScoreComponentController implements angular.IComponentController, IDriverScoreComponentBindings {

    driver: IDriver;
    score: IDriverScores;

    static $inject = [];

    constructor() {
    }

    $onInit(): void {
    }
}

export class DriverScoreComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            driver: "<",
            score: "<"
        };

        this.controller = DriverScoreComponentController;
        this.template = require("./driverScore.html");
    }
}
